"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethods = exports.PaymentMethod = void 0;
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod[PaymentMethod["Cash"] = 0] = "Cash";
    PaymentMethod[PaymentMethod["Online"] = 1] = "Online";
    PaymentMethod[PaymentMethod["Partner"] = 2] = "Partner";
    PaymentMethod[PaymentMethod["StatementOfBooking"] = 3] = "StatementOfBooking";
})(PaymentMethod || (exports.PaymentMethod = PaymentMethod = {}));
exports.PaymentMethods = {
    Cash: PaymentMethod.Cash,
    Online: PaymentMethod.Online,
    Partner: PaymentMethod.Partner,
    StatementOfBooking: PaymentMethod.StatementOfBooking,
};
//# sourceMappingURL=PaymentMethod.js.map